import React, { useEffect, useRef, useCallback, useMemo, useImperativeHandle, forwardRef, useState } from 'react';

import { Popup } from 'devextreme-react/popup';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { Button } from 'devextreme-react/button';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import AntLocalization from '../utils/AntLocalization';

export default forwardRef(function (props, ref) {
    const getDefaultButtons = () => {
        var buttons = [];
        if (props.buttons)
            for (let i = 0; i < props.buttons.length; i++) {
                const button = props.buttons[i];
                buttons.push({
                    index: i,
                    ...button,
                    is_processing: false
                });
            }
        return buttons;
    };

    const show = (args, onClosed) => {
        var title = args.title;
        var content = args.content;
        var buttons = args.buttons;
        var cancelText = args.cancelText;
        var cancelIcon = args.cancelIcon;

        var btns = props.buttons instanceof Array ? [...props.buttons] : [];
        if (buttons instanceof Array) btns.push(...buttons);

        var newBtns = [];
        for (let i = 0; i < btns.length; i++) {
            const button = btns[i];
            newBtns.push({
                index: i,
                ...button,
                is_processing: false
            });
        }

        setButtons(newBtns);
        setOpts({
            title: AntLocalization.translateText(title ? title : opts.title),
            content: AntLocalization.translateText(content ? content : undefined),
            cancelText: AntLocalization.translateText(cancelText ? cancelText : opts.cancelText),
            cancelIcon: cancelIcon ? cancelIcon : opts.cancelIcon
        });
        onClosedCallback.current = onClosed;

        setVisible(true);
    };

    
    const close = async (button) => {
        if (onClosedCallback.current) await onClosedCallback.current(button);

        setVisible(false);
    };

    const handleOnClick = (e) => {
        if (e.element.id && String(e.element.id).indexOf('ant-message-button-id-') > -1) {
            var index = String(e.element.id).replace('ant-message-button-id-', '');
            index = parseInt(index);

            var button = buttons[index];

            if (button) {
                button.is_processing = true;
                setButtons(buttons);

                setTimeout(() => {
                    close(button);
                }, 200);
            }
        }
    };

    const [opts, setOpts] = useState({
        title: 'Thông báo',
        content: '',
        cancelText: '',
        cancelIcon: ''
    });

    const [visible, setVisible] = useState(false);
    const [buttons, setButtons] = useState(getDefaultButtons());
    const onClosedCallback = useRef();

    useImperativeHandle(ref, () => ({
        show: show,
        close: close
    }));

    useEffect(() => {
        if (visible) {
            if (props.onShowed) props.onShowed();
        } else {
            if (props.onClosed) props.onClosed();
        }
    }, [visible]);

    return (
        <React.Fragment>
            <Popup
                wrapperAttr={{
                    class: 'ant-popup'
                }}
                visible={visible}
                onHiding={close}
                dragEnabled={false}
                hideOnOutsideClick={false}
                resizeEnabled={true}
                showTitle={true}
                defaultHeight={props.height ? props.height : 200}
                defaultWidth={props.width ? props.width : 500}
                title={AntLocalization.translateText(props.title ? props.title : opts.title)}
                position={'center'}
                animation={{
                    show: {
                        type: 'fadeIn',
                        duration: 600,
                        from: {
                            scale: 0.55
                        }
                    },
                    hide: {
                        type: 'fadeOut',
                        duration: 600,
                        to: {
                            opacity: 0,
                            scale: 0.55
                        },
                        from: {
                            opacity: 1,
                            scale: 1
                        }
                    }
                }}
            >
                <Box direction="col" height="100%" width="100%">
                    <BoxItem ratio={1}>
                        <span
                            style={{
                                marginLeft: props.marginLeft ? props.marginLeft : 10,
                                marginRight: props.marginRight ? props.marginRight : 10,
                                marginTop: props.marginTop ? props.marginTop : 10,
                                fontSize: props.fontSize ? props.fontSize : 'larger'
                            }}
                        >
                            {AntLocalization.translateText(props.content ? props.content : opts.content)}
                        </span>
                    </BoxItem>
                    <BoxItem baseSize={50}>
                        <Toolbar className="ant-bottom-bar">
                            {buttons.map((button, i) => {
                                return (
                                    <Item key={i} location={button.location ? button.location : 'after'}>
                                        <Button
                                            id={'ant-message-button-id-' + button.index}
                                            onClick={handleOnClick}
                                            type={button.type ? button.type : 'normal'}
                                            className="ant-processing-button"
                                            width={button.width ? button.width : 120}
                                        >
                                            <LoadIndicator
                                                className="ant-indicator-small"
                                                visible={button.is_processing}
                                                // style={{
                                                //     display: !button.is_processing ? 'none' : 'inline-block'
                                                // }}
                                            />
                                            <i
                                                className={'dx-icon dx-icon-' + button.icon}
                                                style={{
                                                    marginRight: 9,
                                                    display: button.is_processing ? 'none' : 'inline-block'
                                                }}
                                            ></i>

                                            <span className="dx-button-text">
                                                {AntLocalization.translateText(button.is_processing ? button.waiting_text : button.text)}
                                            </span>
                                        </Button>
                                    </Item>
                                );
                            })}

                            <Item
                                location="after"
                                widget="dxButton"
                                className="ant-processing-button"
                                options={{
                                    icon: opts.cancelIcon ? opts.cancelIcon : 'close',
                                    text: opts.cancelText ? opts.cancelText : 'OK',
                                    type: 'normal',
                                    onClick: close
                                }}
                            />
                        </Toolbar>
                    </BoxItem>
                </Box>
            </Popup>
        </React.Fragment>
    );
});
